import type { SedeConfig } from './types'
import { verdeVercelli } from './verde-vercelli'
import { verdeValsesia2 } from './verde-valsesia-2'
import { verdeVercelli2 } from './verde-vercelli-2'

/**
 * Pure sede registry — no DOM references, safe to import from Node
 * contexts (vite.config.ts) to render per-site SEO at build time.
 *
 * Add a new sede: import its config above, append it here, and add a
 * domain server block in docker/nginx/nginx.conf. For dev, also add a
 * port → sede entry in ./runtime.ts's DEV_PORT_MAP.
 */
export const ALL_SEDI: readonly SedeConfig[] = [
  verdeVercelli,
  verdeValsesia2,
  verdeVercelli2,
  // verdeBiella,
  // verdeMonferrato,
  // verdePiemonte,
] as const

/** Default when no VITE_SITE_SLUG or hostname match is available. */
export const DEFAULT_SEDE = ALL_SEDI[0]
